import { render, staticRenderFns } from "./InputDiv.vue?vue&type=template&id=3931d08d&lang=html&"
import script from "./InputDiv.vue?vue&type=script&lang=js&"
export * from "./InputDiv.vue?vue&type=script&lang=js&"
import style0 from "./InputDiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports